module.exports = __webpack_public_path__ + "img/duplicate.cc438e72.svg";